import { type ComponentProps } from 'react'
import { Switch as BasisSwitch } from './basis/switch'
import { cn } from '@/utils'

export type SwitchProps = Omit<
  ComponentProps<typeof BasisSwitch>,
  'checked' | 'onCheckedChange'
> & {
  checked: boolean
  onCheckedChange: (checked: boolean) => void
  /** sm: compact (persona editor rows); md: default (basis sizing) */
  size?: 'sm' | 'md'
}

// Basis's <Switch> doesn't expose a size prop (its thumb classes are fixed
// inline, not merged with an external className). The `sm` variant shrinks
// the track via className (twMerge overrides basis's own h-/w- utilities)
// and the thumb via a descendant selector targeting basis's `data-slot`
// marker (`**:data-[slot=...]`) — that selector's specificity beats the
// thumb's own bare utility class regardless of Tailwind's stylesheet order.
export function Switch({ className, size = 'md', ...props }: SwitchProps) {
  return (
    <BasisSwitch
      className={cn(
        size === 'sm' && 'h-4 w-7 **:data-[slot=switch-thumb]:size-3',
        className
      )}
      {...props}
    />
  )
}

Switch.displayName = 'Switch'
